export const makeApiPriceUrl = (): string =>
  `https://api.precificador.autoblue.com.br/public/pricing`;
